export { default } from './CondoLandingScreen';
